import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const paralysis: AnswerPathTreeNode = {
  path: 'paralysis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredParalysisDetails }],
};
